var map = {
	"./marker-icon-2x-blue.png": 171,
	"./marker-icon-2x-braun.png": 172,
	"./marker-icon-2x-orange.png": 173,
	"./marker-icon-2x-purple.png": 174,
	"./marker-icon-2x-red.png": 175,
	"./marker-icon-blue.png": 223,
	"./marker-icon-braun.png": 224,
	"./marker-icon-orange.png": 225,
	"./marker-icon-purple.png": 226,
	"./marker-icon-red.png": 227
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 222;